import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AdminDataInt, AdminResponseInt } from '@interfaces/*';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { AdminMapper } from '@app/mappers';
import { Admin } from '@app/enums';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private mapperAdmin = new AdminMapper();
  // BFF sin cifrar por ahora (encrypted: false en encrypted-services.config).
  private url = `${environment.urlApiCheckinBFF}${environment.versionCheckin}/kiosk/checkin/profile`;
  admin: AdminDataInt = null;
  excludeFields = [Admin.DEFAULT_LANGUAGE, Admin.LOCALES, Admin.PORT_PINPAD];
  staticFields = [Admin.CURRENCY, Admin.CURRENCYCODE, Admin.STORE];

  constructor(private http: HttpClient) {}

  getKioskProfile(kioskId: string = 'ATOMEXK01'): Observable<AdminDataInt> {
    const p = {
      id: kioskId,
    };

    const headers = new HttpHeaders({
      'x-transaction-id': uuidv4(),
      channel: environment.channel,
    });

    const params = new HttpParams({ fromObject: p });

    return this.http
      .get<AdminResponseInt>(`${this.url}`, { params, headers })
      .pipe(map((res: AdminResponseInt) => this.mapperAdmin.mapDTOModel(res)));
  }

  getDataAdminInt() {
    return {
      currency: this.admin?.currency,
      currencyCode: this.admin?.currencyCode,
      DEFAULT_LANGUAGE: this.admin?.DEFAULT_LANGUAGE,
      HomeMessage_en: this.admin?.HomeMessage_en,
      HomeMessage_es: this.admin?.HomeMessage_es,
      store: this.admin?.store,
      Location: this.admin?.Location,
      LOCALES: this.admin?.LOCALES,
      maletas25KG: this.admin?.maletas25KG,
      bagTag: this.admin?.bagTag,
      DOCV: this.admin?.DOCV,
      HANDLE_OVERWEIGHT_BAG: this.admin?.HANDLE_OVERWEIGHT_BAG,
      noPassportScanner: this.admin?.noPassportScanner,
      outOfService: this.admin?.outOfService,
      Payment: this.admin?.Payment,
      scale: this.admin?.scale,
      SHOW_OVERBOOKING_VOLUNTEER_OFFER: this.admin?.SHOW_OVERBOOKING_VOLUNTEER_OFFER,
      SHOW_PREMIERE_OFFER: this.admin?.SHOW_PREMIERE_OFFER,
      SHOW_SEAT_SELECT_PREMIERE_OFFER: this.admin?.SHOW_SEAT_SELECT_PREMIERE_OFFER,
      TSA: this.admin?.TSA,
      WAIT_FOR_AGENT: this.admin?.WAIT_FOR_AGENT,
      AM_PLUS_UPSELL: this.admin?.AM_PLUS_UPSELL,
      Payment_And_Weighing_Test: this.admin?.Payment_And_Weighing_Test,
      country: this.admin?.country,
      INTERNATIONALROUTES: this.admin?.INTERNATIONALROUTES,
      USA_REQUIREMENTS: this.admin?.USA_REQUIREMENTS,
      showIrops: this.admin?.showIrops,
      showUSPerson: this.admin?.showUSPerson,
      showSeatMap: this.admin?.showSeatMap,
      upgradeSeats: this.admin?.upgradeSeats,
      portPinpad: this.admin?.portPinpad,
    };
  }
}
